import { z } from "zod";

/**
 * Company-wide stats for the Campaigns overview page's stat strip and tab bubbles (PREC-3880).
 * The engagement numbers span every non-archived, visible list with at least one campaign in the
 * requested ownership scope, and mirror the canonical per-campaign definitions
 * (see `campaignSummarySchema`):
 * - `contacted` — leads with at least one conversation `sentAt`.
 * - `replied`   — leads with a real inbound reply (auto-replies excluded, PREC-3949).
 * - `positive`  — replied leads whose best conversation sentiment is INTERESTED.
 *
 * `campaignCounts` is scope-independent (always mine/team/all) so the tab bubbles stay stable
 * while the strip follows the active tab. SQL aggregates arrive as strings from the MySQL driver,
 * hence `z.coerce.number()` throughout.
 */
export const campaignsOverviewStatsSchema = z.object({
	runningCampaigns: z.coerce.number(),
	totalCampaigns: z.coerce.number(),
	listCount: z.coerce.number(),
	contacted: z.coerce.number(),
	replied: z.coerce.number(),
	positive: z.coerce.number(),
	campaignCounts: z.object({
		mine: z.coerce.number(),
		team: z.coerce.number(),
		all: z.coerce.number(),
	}),
});

export type CampaignsOverviewStats = z.infer<typeof campaignsOverviewStatsSchema>;
